<template>
  <div class="page-school-wrapper">
    <!-- 头部 -->
    <Header />
    <!-- 侧边菜单 -->
    <SliderBar />
    <!-- 中间部分路由页面 -->
    <div class="page-school-inside">
      <a-config-provider :locale="locale">
        <router-view></router-view>
      </a-config-provider>
    </div>
  </div>
</template>

<script>
import Header from "../../components/Header.vue"
import { mapState } from "vuex";
import SliderBar from "../../components/school/SliderBar.vue"
import zhCN from 'ant-design-vue/lib/locale-provider/zh_CN';
import "../../assets/css/school.less"
import "../../assets/css/searchTable.less"

export default {
  name: "SchoolIndex",
  components: {
    Header,
    SliderBar,
  },
  data () {
    return {
      locale: zhCN,
    };
  },
  computed: {
    ...mapState({
      appsUserInfo: state => state.appsLogin.appsUserInfo,
    }),
  }
}
</script>

<style lang="less" scoped>
</style>